import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Message } from 'primeng/message';

@Component({
  selector: 'inpla-permissions-retry-banner',
  imports: [TranslatePipe, ButtonModule, Message],
  templateUrl: './permissions-retry-banner.component.html',
  styleUrl: './permissions-retry-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionsRetryBannerComponent {
  public readonly retry = output<void>();
}
